var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 10.25L10.9219 6.54688L10.125 5.75L7.20312 8.65625L5.875 7.34375L5.07813 8.14062L7.20312 10.25ZM8 14C7.17708 14 6.40104 13.8438 5.67188 13.5312C4.94271 13.2188 4.30469 12.7891 3.75781 12.2422C3.21094 11.6953 2.78125 11.0573 2.46875 10.3281C2.15625 9.59896 2 8.82292 2 8C2 7.16667 2.15625 6.38802 2.46875 5.66406C2.78125 4.9401 3.21094 4.30469 3.75781 3.75781C4.30469 3.21094 4.94271 2.78125 5.67188 2.46875C6.40104 2.15625 7.17708 2 8 2C8.83333 2 9.61198 2.15625 10.3359 2.46875C11.0599 2.78125 11.6953 3.21094 12.2422 3.75781C12.7891 4.30469 13.2188 4.9401 13.5312 5.66406C13.8438 6.38802 14 7.16667 14 8C14 8.82292 13.8438 9.59896 13.5312 10.3281C13.2188 11.0573 12.7891 11.6953 12.2422 12.2422C11.6953 12.7891 11.0599 13.2188 10.3359 13.5312C9.61198 13.8438 8.83333 14 8 14Z",
    fill: "#147D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c68fc9feb4df499065408a628d328b5b.svg";
export { ForwardRef as ReactComponent };